// extracted by mini-css-extract-plugin
export default {"actionsView":"styles_actionsView__i1UQh","singleAction":"styles_singleAction__SDNEq","ui-spin":"styles_ui-spin__xgtVg"};